<template>
  <div>
    <h4>Неправильные названия прототипов уровней</h4>
    <p class="mb-3">
      При импорте уровней из конф-файлов в MySQL
      информация по уровням сохранятеся в MySQL
      в таблице <code>insider_m3_levels</code> (в главной БД, а&nbsp;не&nbsp;на&nbsp;шардах).
    </p>

    <b-button @click="fix">Исправить названия прототипов в MySQL</b-button>

<!--
    <loading-indicator v-if="isLoading"/>

    <p v-if="message !== null">
      {{message}}
    </p>

    <table v-if="isDefectTableVisible" class="table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col">№</th>
          <th scope="col">Ид проследовательности</th>
          <th scope="col">Ид уровня</th>
          <th scope="col">Название уровня из конф-файла</th>
          <th scope="col">Название уровня из MySQL</th>
        </tr>
        <tr v-for="(defect, index) in defects" :key="defect.levelProtoId">
          <td>{{index+1}}</td>
          <td>{{defect.sequenceProtoId}}</td>
          <td>{{defect.levelProtoId}}</td>
          <td>{{defect.levelProtoNameInConfFile}}</td>
          <td>{{defect.levelProtoNameInMySQL}}</td>
        </tr>
      </thead>
    </table>
-->

  </div>
</template>

<script>
import { HTTP } from '../../http-common.js';

import notifier from '../../notifier.js';
//import LoadingIndicator from '../LoadingIndicator.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'InvalidLevelProtoNames',

  components: {
    //LoadingIndicator,
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,

      /** @type {Defect[] | null} */
      defects: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },

    /** @returns {?string} */
    message() {
      if(this.isLoadedNormal && (this.defects !== null) && (this.defects.length === 0)) {
        return 'Нет ошибок.';
      }

      return null;
    },

    /** @returns {boolean} */
    isDefectTableVisible() {
      if(!this.isLoadedNormal) {
        return false
      }

      return (this.defects !== null) && (this.defects.length > 0);
    },
  },

  created() {
    //this.loadInvalidLevelProtoNameInMySQLDefects();
  },

  methods: {
    fix() {
      HTTP.post('/m3/fix_level_proto_names_in_mysql')
      .then(() => {
        notifier.showSuccess('Названия исправлены.');
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

    loadInvalidLevelProtoNameInMySQLDefects() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const url = '/m3/invalid_level_proto_name_in_mysql_defects';
      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          this.loadState = LOAD_STATE_LOADED_ERROR;
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.defects = data;

        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(err => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },
};

/**
 * @typedef {Object} Defect
 * @property {number} sequenceProtoId
 * @property {number} levelProtoId
 * @property {string} levelProtoNameInConfFile
 * @property {string} levelProtoNameInMySQL
 */
</script>
